import type { FacilityMetaAddress } from './tier2submit-export.ts';

export type ReportValidation = { errors: string[]; warnings: string[] };
const US_STATES = new Set(
  'AL AK AZ AR CA CO CT DE DC FL GA HI ID IL IN IA KS KY LA ME MD MA MI MN MS MO MT NE NV NH NJ NM NY NC ND OH OK OR PA RI SC SD TN TX UT VT VA WA WV WI WY AS GU MP PR VI'.split(
    ' ',
  ),
);
export const zipValid = (zip: string) => /^\d{5}(-\d{4})?$/.test(zip.trim());
export function addressValidation(address: FacilityMetaAddress, label: string, required: boolean) {
  const errors: string[] = [],
    warnings: string[] = [];
  const fieldIssues: Record<keyof FacilityMetaAddress, ReportValidation> = {
    street: { errors: [], warnings: [] },
    city: { errors: [], warnings: [] },
    state: { errors: [], warnings: [] },
    zip: { errors: [], warnings: [] },
    country: { errors: [], warnings: [] },
  };
  const fields = [
    ['street', 'street'],
    ['city', 'city'],
    ['state', 'state/province'],
    ['zip', 'postal code'],
    ['country', 'country'],
  ] as const;
  const any = fields.some(([key]) => address[key].trim());
  if (!any && !required) return { errors, warnings, fieldIssues };
  const missing = fields.filter(([key]) => !address[key].trim()).map(([, name]) => name);
  if (missing.length) errors.push(label + ': enter ' + missing.join(', ') + '.');
  for (const [key, name] of fields) if (!address[key].trim()) fieldIssues[key].errors.push('Enter ' + name + '.');
  if (US_STATES.has(address.state.toUpperCase()) && address.country && address.country !== 'USA') {
    errors.push(label + ': country must be USA when a US state or territory is selected.');
    fieldIssues.country.errors.push('Choose USA when a US state or territory is selected.');
  }
  if (address.country === 'USA' && address.zip && !zipValid(address.zip)) {
    warnings.push(label + ': ZIP code should be five digits or ZIP+4.');
    fieldIssues.zip.warnings.push('ZIP code should be five digits or ZIP+4.');
  }
  return { errors, warnings, fieldIssues };
}
